import { addAccount, addCashRecord, addRole, deleteAccount, deleteBook, deleteCashRecord, deleteRole, deleteUser, getCashRecordStats, register, searchAccount, searchBook, searchCashRecord, searchRole, searchUser, updateAccount, updateBook, updateCashrecord, updateRole, updateUser, upload } from "./EndPoints";


export const AllPermissionList = [
    {
        value: "dashboard",
        url: [],
        permission: [
            {
                read: { allowed: false, url: [getCashRecordStats] },
                write: { allowed: false, url: [] },
                delete: { allowed: false, url: [] },
            }
        ],
        child: []
    },
    {
        value: "rolesAndPermissions",
        url: [],
        permission: [
            {
                read: { allowed: false, url: [searchRole] },
                write: { allowed: false, url: [addRole, updateRole] },
                delete: { allowed: false, url: [deleteRole] },
            }
        ],
        child: []
    },
    {
        value: "user",
        url: [],
        permission: [
            {
                read: { allowed: false, url: [searchUser, searchRole] },
                write: { allowed: false, url: [register, updateUser] },
                delete: { allowed: false, url: [deleteUser] },
            }
        ],
        child: []
    },
    {
        value: "account",
        url: [],
        permission: [
            {
                read: { allowed: false, url: [searchAccount] },
                write: { allowed: false, url: [addAccount, updateAccount] },
                delete: { allowed: false, url: [deleteAccount] },
            }
        ],
        child: []
    },
    {
        value: "cashbook",
        url: [],
        permission: [
            {
                read: { allowed: false, url: [searchCashRecord, searchRole, addCashRecord] },
                write: { allowed: false, url: [updateCashrecord, upload] },
                delete: { allowed: false, url: [deleteCashRecord] },
            }
        ],
        child: []
    },

    {
        value: "book",
        url: [],
        permission: [
            {
                read: { allowed: false, url: [searchBook, searchRole] },
                write: { allowed: false, url: [updateBook] },
                delete: { allowed: false, url: [deleteBook] },
            }
        ],
        child: []
    },


];